import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  // 获取城市分级
  getCityLevel({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`urbanCompetitiveness/getCityLevel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取城市竞争力
  getCityCompetitiveness({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`urbanCompetitiveness/getCityCompetitiveness`,params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 列表查询
  findList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`urbanCompetitiveness/selectData`,params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 导出
  exportData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/urbanCompetitiveness/exportData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 导入
  importExcel({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/urbanCompetitiveness/importExcel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}
